const theme = {
  color: {
    primary: '#3694E3',
    secondary: '#3A3A3A'
  }
}

export default theme
